<template>
    <div class="time-line text-center">
        <button type="button"
                v-for="step in totalStepsToShow"
                v-bind:class="stepClasses(step)"
                :key="step"
                class="btn btn-default btn-circle">{{step}}
        </button>
        <button type="button" class="btn btn-default btn-circle" v-bind:class="{ current: isComplete }">
            <i class="fa fa-check"></i>
        </button>
    </div>
</template>

<script>
  export default {
    name: 'Steps',
    props: ['totalSteps', 'currentStep', 'isComplete'],
    computed: {
      totalStepsToShow () {
        return +this.totalSteps < 5 ? +this.totalSteps : 5
      },
      currentStepToShow () {
        let math = +this.currentStep / +this.totalSteps
        let rawCurrentStepToShow = this.totalStepsToShow * math

        return Math.ceil(rawCurrentStepToShow)
      }
    },
    methods: {
      stepClasses: function (step) {
        if (this.isComplete || step < this.currentStepToShow) {
          return 'visited'
        }

        if (this.currentStepToShow === step) {
          return 'current'
        }

        return ''
      }
    }
  }
</script>

